import React from "react";
import FilterList from "../../../components/user/productionOrderSap/productionOrderSapFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const ProductionOrderSapListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

ProductionOrderSapListPage.propTypes = {};

export default ProductionOrderSapListPage;
